import { fg } from '@atlaskit/platform-feature-flags';

import { safeWarnWithoutCustomerData } from './utils';

const idTypeMap = new Map<string, { typeName: string; hasLoggedConflict: boolean }>();

export default function RelayDataID(
	fieldValue: {
		[key: string]: unknown;
	},
	typeName: string,
): string | undefined {
	const { id } = fieldValue;
	if (id == null) {
		return undefined;
	}

	if (fg('platform_log_relay_duplicate_identifiers')) {
		const idString = String(id);

		if (idTypeMap.has(idString)) {
			const entry = idTypeMap.get(idString);
			if (entry) {
				const { typeName: existingTypeName, hasLoggedConflict } = entry;
				if (existingTypeName !== typeName && !hasLoggedConflict) {
					safeWarnWithoutCustomerData(
						'relaydataid.generator',
						`RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`,
						{
							id: idString,
							types: `${existingTypeName}, ${typeName}`,
						},
					);
					entry.hasLoggedConflict = true;
				}
			}
		} else {
			idTypeMap.set(idString, { typeName, hasLoggedConflict: false });
		}
	}

	return `${String(id)}:::::${typeName}`;
}
